import { configureStore } from "@reduxjs/toolkit";
import statementFilterReducer from "../features/statementFilter/statementFilterSlice";
import transactionReducer from "../features/transaction/transactionSlice";

export const store = configureStore({
    reducer: {
        transaction: transactionReducer,
        statementFilter: statementFilterReducer,
    },
});
